import TraceabilityReport from './TraceabilityReport';
import TraceabilityReportConnector from './TraceabilityReportConnector';

const ConnectedComponent = () => <TraceabilityReportConnector component={TraceabilityReport} />;

export default ConnectedComponent;
